module.exports = __webpack_public_path__ + "img/chara-head-1.83cd7097.png";